import { logUsage } from 'owa-analytics';
import { ActionSource } from 'owa-mail-store';

export default function logRetentionPolicySelected(config: {
    isArchiveTag: boolean;
    actionSource: ActionSource;
    responseClass: string;
}) {
    const { isArchiveTag, actionSource, responseClass } = config;
    logUsage('TnS_RetentionPolicySelected', [isArchiveTag, actionSource, responseClass]);
}
